import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Shell({ children, footer = true }) {
  return (
    <div className="relative min-h-screen bg-background">
      <div className="grain-overlay" />
      <div className="relative z-10">
        <Navbar />
        {children}
        {footer && <Footer />}
      </div>
      <ChatWidget />
    </div>
  );
}
